import { create } from "zustand";
import DashboardParams from "../interfaces/dashboardParams";

interface DashboardStore {
  params: DashboardParams;

  setParams: (params: DashboardParams) => void;
}

const useDashboardStore = create<DashboardStore>((set: any) => ({
  params: {
    medals: null,
    startDate: null,
    endDate: null,
  },

  setParams: (params: DashboardParams) => set(() => ({ params })),
}));

export default useDashboardStore;
